import get from 'lodash/get';
import update from 'immutability-helper';
import createMappedReducer from 'src/common/reducers/utils/createMappedReducer';
import asyncStatuses from 'src/common/utils/asyncStatuses';

import {
  GET_SIGNATURE,
  CREATE_SUBSCRIPTION,
  GET_SUBSCRIPTION,
  CANCEL_SUBSCRIPTION,
  RENEW_SUBSCRIPTION,
  FETCH_COUPON,
} from '../actions/subscription';

import { LOGOUT } from '../actions/auth';

import {
  GET_LOCATION,
  SET_LOCATION,
  SET_LOCATION_OPTIONS,
  LOCATION_NOT_FOUND,
} from '../actions/location';
import { fulfilled, pending, rejected } from './utils/asyncActionNameSuffixes';
import createRequestLifecycleHandlers from './utils/createRequestLifecycleHandlers';

const initialState = {
  current: {},
};

export const subscription = createMappedReducer(initialState, {
  ...createRequestLifecycleHandlers({ fetchActionNameRoot: GET_SIGNATURE }),
  ...createRequestLifecycleHandlers({
    fetchActionNameRoot: CREATE_SUBSCRIPTION,
  }),
  ...createRequestLifecycleHandlers({
    fetchActionNameRoot: RENEW_SUBSCRIPTION,
  }),
  [fulfilled(GET_SUBSCRIPTION)](state, action) {
    return update(state, {
      isFetching: { $set: false },
      current: { $set: get(action, 'payload.content') },
    });
  },
  [rejected(GET_SUBSCRIPTION)](state) {
    return {
      ...state,
      isFetching: false,
      current: {
        hasFailed: true,
      },
    };
  },
  [pending(GET_SUBSCRIPTION)](state) {
    return {
      ...state,
      isFetching: true,
    };
  },
  [pending(CANCEL_SUBSCRIPTION)](state) {
    return {
      ...state,
      cancellationStatus: asyncStatuses.pending,
    };
  },
  [fulfilled(CANCEL_SUBSCRIPTION)](state, action) {
    return {
      ...state,
      cancellationStatus: asyncStatuses.fulfilled,
      current: get(action, 'payload.data'),
    };
  },
  [rejected(CANCEL_SUBSCRIPTION)](state) {
    return {
      ...state,
      cancellationStatus: asyncStatuses.rejected,
    };
  },
  [fulfilled(RENEW_SUBSCRIPTION)](state, action) {
    return update(state, {
      [action.meta.contentId]: {
        $merge: {
          loadedTime: action.payload.loadedTime,
          isFetching: false,
        },
      },
      current: { $set: get(action, 'payload.content') },
      paymentInfo: { $set: {} },
    });
  },
  [fulfilled(CREATE_SUBSCRIPTION)](state, action) {
    return update(state, {
      [action.meta.contentId]: {
        $merge: {
          loadedTime: action.payload.loadedTime,
          isFetching: false,
        },
      },
      current: { $set: get(action, 'payload.content') },
      paymentInfo: { $set: {} },
    });
  },
  [fulfilled(LOGOUT)]() {
    return initialState;
  },
  [SET_LOCATION](state, action) {
    return update(state, {
      paymentInfo: {
        $merge: {
          country: action.country,
          state: action.state,
        },
      },
    });
  },
  [SET_LOCATION_OPTIONS](state, action) {
    return update(state, {
      paymentInfo: {
        $merge: {
          options: action.locations,
        },
      },
    });
  },
  [GET_LOCATION](state, action) {
    return update(state, {
      paymentInfo: {
        $set: {
          postalCode: action.postalCode,
        },
      },
    });
  },
  [LOCATION_NOT_FOUND](state) {
    return update(state, {
      paymentInfo: {
        $merge: {
          enableManualSelection: true,
        },
      },
    });
  },
  [pending(FETCH_COUPON)](state) {
    return {
      ...state,
      coupon: {
        ...(state.coupon || {}),
        isFetching: true,
      },
    };
  },
  [rejected(FETCH_COUPON)](state, action) {
    return update(state, {
      coupon: {
        $set: {
          isFetching: false,
          hasFailed: true,
          errorStatusCode: get(action, 'payload.response.status'),
          errorStatusText: get(action, 'payload.response.statusText'),
          status: get(action, 'payload.response.data'),
        },
      },
    });
  },
  [fulfilled(FETCH_COUPON)](state, action) {
    return update(state, {
      coupon: {
        $set: {
          isFetching: false,
          loadedTime: action.payload.loadedTime,
          ...action.payload.data,
        },
      },
    });
  },
});
